import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * @param {{ surface: string, encounterRef: string, event: string, previousRef?: string }} args
 */
export async function recordAmbientListeningEvent(args) {
  const callable = httpsCallable(getFunctions(), "recordAmbientListeningEvent");
  const result = await callable(args);
  return result?.data;
}
